<div [class.padding-top-large]="paddingTopLarge" class="content-wrap" layout-centered padding>
  <rt-feature-guard-content
    [featureData]="featureData"
    [canUpgrade]="canUpgrade"
    (openPlanPicker)="openPlanPicker()"
  >
  </rt-feature-guard-content>
</div>
